export default (name: string): string => {
  if (typeof window !== 'undefined') {
    // location search only has parameters IF user entered DIRECTLY to request a form page, SessionStorage should be principal entry
    const queryPropagated = window.sessionStorage.getItem('query_pass');
    if (queryPropagated) {
      const match = RegExp('[?&]' + name + '=([^&]*)').exec(`?${queryPropagated}`);
      return match && decodeURIComponent(match[ 1 ].replace(/\+/g, ' '));
    } else {
      // Session storage has no propagated UTM queries, use location as alternative
      const match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
      return match && decodeURIComponent(match[ 1 ].replace(/\+/g, ' '));
    }
  }
}
